<div class="report-view" id="report-view">
    <header class="report-actions" data-html2canvas-ignore>
        <app-report-select-form
            [title]="'reports.compare.group.shortLabel' | translate"
            [maxCompare]="2"
            [selectGroups]="selectGroups"
            [years]="years"
            compareType='group'></app-report-select-form>
    </header>

    <app-report-wrapper [selMode]="reportMode.compare"></app-report-wrapper>
</div>

<div class="mobile-message">
    <p>{{'main.mobileMessage.summary' | translate}}</p>
</div>
